module.exports = __webpack_public_path__ + "img/ios-icon-step1-iphone.c2bf36d3.png";